var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgUndo = function SvgUndo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.535 8.46A4.97 4.97 0 0 0 19 7H2.8l4.3-4.3a1 1 0 1 0-1.418-1.412L.732 6.237a2.5 2.5 0 0 0 0 3.535l4.95 4.95A1.001 1.001 0 0 0 7.1 13.31l-4.312-4.31H19a3 3 0 0 1 3 3v7a3 3 0 0 1-3 3H5a1 1 0 0 0 0 2h14a5.006 5.006 0 0 0 5-5v-7a4.97 4.97 0 0 0-1.465-3.54"
  })));
};
export default SvgUndo;